import httpClient from '../helpers/httpClient'

export async function invoiceApi(path, data, method = 'post') {
  const response = await httpClient({ url: `${import.meta.env.VITE_API_URL}/api${path}`, method, data })
  // Existing shared client resolves HTTP 400; never treat validation failure as success.
  if (response.status >= 400) throw new Error(response.data?.message || 'Request failed')
  return response.data
}

export const invoiceError = error => error.response?.data?.message || error.message || 'Request failed'
export const formatMoney = value => new Intl.NumberFormat('nl-BE', { style: 'currency', currency: 'EUR' }).format(Number(value))
